/** Where a Needs you email's "Review and decide" link lands (#1778): `/decide/<token>`. */
export const DECIDE_PATH = '/decide'

/**
 * Whether `path` is a screen a person reaches without signing in, because the credential is in the address itself: the
 * decide page a Needs you email links to (#1778). App.vue draws such a screen on its own, outside both the sign-in
 * screen and the signed-in shell, and the onboarding landing never moves a person off one.
 *
 * Nothing here opens data to anybody: the page reads only what its token lets the API answer.
 */
export function isPublicScreen(path: string): boolean {
    const target = path.split(/[?#]/)[0] ?? ''
    return target.startsWith(`${DECIDE_PATH}/`) && target.length > DECIDE_PATH.length + 1
}
